module.exports = __webpack_public_path__ + "static/img/assisted1.d29be244.png";